import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Login from '@/views/Login.vue';
import Dashboard from '@/views/Dashboard.vue';
import Profile from '@/views/Profile.vue';
import Password from '@/views/Password.vue';
import WinLoseMember from '@/views/WinLoseMember.vue';
import ProviderReport from '@/views/ProviderReport.vue';
// import UserOnline from '@/views/UserOnline.vue';
import UserOnlineSocket from '@/views/UseOnlineSocket.vue';
// import CreateAccount from '@/views/CreateAccount.vue';
import Downline from '@/views/Downline.vue';
import SubAccount from '@/views/SubAccount.vue';
import DepositWithdraw from '@/views/DepositWithdraw.vue';
import SuggestMember from '@/views/SuggestMember.vue';
import store from '@/store';
// import MemberOutstanding from '@/views/MemberOutstanding.vue';
import Message from '@/views/Message.vue';
import Banner from '@/views/Banner.vue';
import Bet from '@/views/Bet.vue';
import BetCancel from '@/views/BetCancel.vue';
import Payout from '@/views/Payout.vue';
import Recal from '@/views/Recal.vue';
// import Statement from '@/views/Statement.vue';
import AddSubAccount from '@/views/AddSubAccount.vue';
import AddAgent from '@/views/AddAgent.vue';
import EditAgent from '@/views/EditAgent.vue';
import AddMember from '@/views/AddMember.vue';
import EditMember from '@/views/EditMember.vue';
import EditSubAccount from '@/views/EditSubAccount.vue';
import SeamlessKey from '@/views/SeamlessKey.vue';
import TransferKey from '@/views/TransferKey.vue';
import Social from '@/views/Social.vue';
// import Promotion from '@/views/Promotion.vue';
import Flag from '@/views/Flag.vue';
import Bankaccount from '@/views/BankAccount.vue';
import CryptoAccount from '@/views/CryptoAccount.vue';
import Invoice from '@/views/Invoice.vue';
import DocumentApi from '@/views/DocumentApi.vue';
import Point from '@/views/Point.vue';
import Maintenance from '@/views/Maintenance.vue';
import SecretPassword from '@/views/SecretPassword.vue';
import EvoplaySessions from '@/views/EvoplaySessions.vue';
import UserSeamlessProblem from '@/views/UserSeamlessProblem.vue';
import GamesManagement from '@/views/GamesManagement.vue';
import ActivityLog from '@/views/Activity.vue';
import ResetPasswordLog from '@/views/ResetPasswordLog.vue';
import Lotto from '@/views/Lotto.vue';
import AccessLog from '@/views/AccessLog.vue';
import PaymentLog from '@/views/PaymentLog.vue';
import UpdateCommissionLog from '@/views/UpdateCommissionLog.vue';
import LegendOfDolly from '@/views/LegendOfDolly.vue';
import MarketingReport from '@/views/MarketingReport.vue';
import User from '@/views/User.vue';
import LogAdmin from '@/views/LogAdmin.vue';
import WebManagement from '@/views/WebManagement.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '*',
    redirect: {
      name: 'Dashboard',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      guest: true,
      layout: 'auth',
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'SUBACCOUNT',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUBACCOUNT',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/password',
    name: 'Password',
    component: Password,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUBACCOUNT',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/winlosemember',
    name: 'WinLoseMember',
    component: WinLoseMember,
    meta: {
      requiresAuth: true,
      permKey: 'report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUBACCOUNT',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/provider-report',
    name: 'ProviderReport',
    component: ProviderReport,
    meta: {
      requiresAuth: true,
      permKey: 'report',
      allow: [
        'COMPANY',
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/game-report',
    name: 'GameReport',
    component: ProviderReport,
    meta: {
      requiresAuth: true,
      permKey: 'report',
      allow: [
        'COMPANY',
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/deposit-withdraw',
    name: 'DepositWithdraw',
    component: DepositWithdraw,
    meta: {
      requiresAuth: true,
      permKey: 'statement',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUBACCOUNT',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  // {
  //   path: '/useronline',
  //   name: 'UserOnline',
  //   component: UserOnline,
  //   meta: {
  //     requiresAuth: true,
  //     permKey: 'useronline',
  //     allow: [
  //       'COMPANY',
  //       'SUBCOMPANY',
  //       'SUPERADMIN',
  //       'ADMIN',
  //       // 'AGENT',
  //       // 'SUBAGENT',
  //     ],
  //   },
  // },
  {
    path: '/useronlineBeta',
    name: 'UserOnlineBeta',
    component: UserOnlineSocket,
    meta: {
      requiresAuth: true,
      permKey: 'useronline',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
        'AGENT',
        // 'SUBAGENT',
      ],
    },
  },
  // {
  //   path: '/createaccount',
  //   name: 'CreateAccount',
  //   component: CreateAccount,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/downline',
    name: 'Downline',
    component: Downline,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'SUBACCOUNT',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/subaccount',
    name: 'SubAccount',
    component: SubAccount,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
      ],
    },
  },
  {
    path: '/add-subaccount',
    name: 'AddSubAccount',
    component: AddSubAccount,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
      ],
    },
  },
  {
    path: '/edit-subaccount',
    name: 'EditSubAccount',
    component: EditSubAccount,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/add-agent',
    name: 'AddAgent',
    component: AddAgent,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/edit-agent',
    name: 'EditAgent',
    component: EditAgent,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'AGENT',
        'SUBAGENT',
        'SUBACCOUNT',
        'SUPERADMIN',
        'ADMIN',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/add-member',
    name: 'AddMember',
    component: AddMember,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'AGENT',
        'SUBAGENT',
        'SUBACCOUNT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/edit-member',
    name: 'EditMember',
    component: EditMember,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
        'SUBAGENT',
        'SUBACCOUNT',
        'SUPERADMIN',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/suggest-member',
    name: 'SuggestMember',
    component: SuggestMember,
    meta: {
      requiresAuth: true,
      permKey: 'suggestion',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUBACCOUNT',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/seamless-key',
    name: 'SeamlessKey',
    component: SeamlessKey,
    meta: {
      permKey: 'apikey',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'SUBACCOUNT',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/transfer-key',
    name: 'TransferKey',
    component: TransferKey,
    meta: {
      permKey: 'apikey',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'SUBACCOUNT',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  // {
  //   path: '/member-outstanding',
  //   name: 'MemberOutstanding',
  //   component: MemberOutstanding,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/message',
    name: 'Message',
    component: Message,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/banner',
    name: 'Banner',
    component: Banner,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/bet',
    name: 'Bet',
    component: Bet,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUBACCOUNT',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/bet-cancel',
    name: 'BetCancel',
    component: BetCancel,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUBACCOUNT',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/payout',
    name: 'Payout',
    component: Payout,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'SUBACCOUNT',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/recal',
    name: 'Recal',
    component: Recal,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUBACCOUNT',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/social',
    name: 'Social',
    component: Social,
    meta: {
      requiresAuth: true,
      allow: [
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  // {
  //   path: '/promotion',
  //   name: 'Promotion',
  //   component: Promotion,
  //   meta: {
  //     requiresAuth: true,
  //     allow: [
  //       'SUBAGENT',
  //       'AGENT',
  //       'SUPERADMIN',
  //       'ADMIN',
  //     ],
  //   },
  // },
  {
    path: '/flag',
    component: Flag,
    name: 'Flag',
    meta: {
      permKey: 'newlobby',
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/bank-account',
    name: 'Bankaccount',
    component: Bankaccount,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'COMPANY',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/usdt-account',
    name: 'UsdtAccount',
    component: CryptoAccount,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'COMPANY',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: Invoice,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'COMPANY',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/document-api',
    name: 'Documentapi',
    component: DocumentApi,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
        'AGENT',
        'SUBCOMPANY',
        'COMPANY',
      ],
    },
  },
  {
    path: '/point',
    name: 'Point',
    component: Point,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
        'AGENT',
        'SUBACCOUNT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/legend-of-dolly',
    name: 'Legend of dolly',
    component: LegendOfDolly,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: Maintenance,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/secret-password',
    name: 'SecretPassword',
    component: SecretPassword,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/evoplay-sessions',
    name: 'EvoplaySessions',
    component: EvoplaySessions,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/user-seamless-problem',
    name: 'User Seamless',
    component: UserSeamlessProblem,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/games-management',
    name: 'GamesManagement',
    component: GamesManagement,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/activity',
    name: 'ActivityLog',
    component: ActivityLog,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/reset-password-log',
    name: 'Reset Password Log',
    component: ResetPasswordLog,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/update-commission-log',
    name: 'Update Commission Log',
    component: UpdateCommissionLog,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/lotto',
    name: 'Lotto',
    component: Lotto,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/access-logs',
    name: 'AccessLogs',
    component: AccessLog,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'AGENT',
        'SUBACCOUNT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/paymentlog',
    name: 'PaymentLog',
    component: PaymentLog,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'AGENT',
      ],
    },
  },
  {
    path: '/game-marketing-report',
    name: 'GameMatketingReport',
    component: MarketingReport,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'COMPANY',
      ],
    },
  },
  {
    path: '/user',
    name: 'User',
    component: User,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/log-admin',
    name: 'LogAdmin',
    component: LogAdmin,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/web-management',
    name: 'WebManagement',
    component: WebManagement,
    meta: {
      requireAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const { isAuthenticated, userPermission, role } = store.getters;
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (isAuthenticated) {
      if ((userPermission[to.meta.permKey] !== 'off'
        && to.meta.allow.includes(role))
        && (!to.meta.isEditPermKey
        || userPermission[to.meta.isEditPermKey] === 'edit')) {
        next();
        return;
      } else {
        next('/dashboard');
        return;
      }
    }
    next('/login');
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (!isAuthenticated) {
      next();
      return;
    }
    next('/dashboard');
  } else {
    next();
  }
});

export default router;
